import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SearchInputModule } from '@epicuro-next/ataraxia/search-input';
import { searchInputPlaceholder } from '@epicuro-next/constants/features/localization';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { OrdersFiltersStore } from '../../store/order-filters-store/order-filters.store';

@Component({
  selector: 'epc-order-search-input',
  imports: [CommonModule, SearchInputModule, ReactiveFormsModule],
  templateUrl: './order-search-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSearchInputComponent implements OnDestroy, OnInit {
  private readonly ordersFilterStore = inject(OrdersFiltersStore);

  @Input() public isLoading = false;
  @Input() public noResult = false;
  @Input() public placeholderText = searchInputPlaceholder;

  public searchControl = new FormControl('');

  public destroy$ = new Subject<void>();

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public ngOnInit(): void {
    this.ordersFilterStore.searchQuery$
      .pipe(takeUntil(this.destroy$))
      .subscribe((searchText) =>
        this.searchControl.setValue(searchText, { emitEvent: false }),
      );

    this.searchControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((searchText) =>
        this.ordersFilterStore.updateSearchQuery(searchText ?? ''),
      );
  }
}
